// extracted by mini-css-extract-plugin
export default {"toastList":"toast-list_toastList__3W6sK"};